import { makeStyles } from '@material-ui/core';

export const styles = makeStyles(() => ({
  versionLabel: {
    position: 'absolute',
    zIndex: 999,
    color: 'white',
    bottom: '2.47vh',
    left: '3.3vw',
    fontSize: '1.3vh',
    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  logo: {
    position: 'absolute',
    zIndex: 999,
    height: 'auto',
    width: '6.58vw',
    bottom: '2.6vh',
    right: '1.46vw',
  },

  '@keyframes startupAnimation': {
    '0%': {
      right: '-6.58vw',
    },
    '36.6%': {
      right: '-6.58vw',
    },
    '40%': {
      right: '1.46vw',
    },
    '100%': {
      right: '1.46vw',
    },
  },

  animation: {
    animation: '$startupAnimation 10s',
  },
}));
